import { Component, OnInit, Input, NgZone } from '@angular/core';
import { LoginService } from './login.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
//import { FacebookService, LoginResponse, LoginOptions } from 'ngx-facebook';
//import { GoogleSignInSuccess } from 'angular-google-signin';
import { ILogin } from './login.interface';
import { NgForm } from '@angular/forms/src/directives/ng_form';
import * as KJUR from 'jsrsasign';
import { error } from 'util';
import { Subscription } from 'rxjs';
import { NotifierService } from '../../system/shared/notifier/notifier.service';
import { UserService } from '../../system/services/usuario.service';
import { AuthService, SocialUser, GoogleLoginProvider } from 'angularx-social-login';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [LoginService, /*FacebookService*/ UserService, AuthService]
})
export class LoginComponent implements OnInit {
  titulo = 'eBioPhy';
  parametro;
  nombre: string;
  loginData: ILogin;
  suscription: Subscription;
  authSubscription: Subscription;
  loginGmail;
  @Input('datos') public datos;
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _loginService: LoginService,
    //private fb: FacebookService,
    private zone: NgZone,
    private notifierService: NotifierService,
    private _userService: UserService,
    private auth: AuthService
  ) {

    /*fb.init({
      appId: '347375275707909',
      version: 'v2.10',
      xfbml: true,
    });*/
  }

  ngOnInit() {
    this.authSubscription = this.auth.authState.subscribe((user: SocialUser) => {
      if (user) {
        console.log(user);
        // this.user = user;
        // tslint:disable-next-line:triple-equals
        if (user.provider == 'GOOGLE') {

          this._loginService.googleLogin(user.idToken).subscribe((result: any) => {
            console.log('result', result);
            localStorage.setItem('jwt', result.JWT);
            this._router.navigate(['system']);
            this._userService.obtenerDatosPersonales()
              .subscribe(
                (userResponse: any) => {
                  localStorage.setItem('nombreCompleto', userResponse.nombres + ' ' + userResponse.apellidos);
                }, error => {
                  console.log('error', error)
                }
              )
            this.auth.signOut();
          }, (error) => {
            console.log('error', error);
            this.notifierService.systemNotify({
              title: 'Atención',
              message: 'Aún no esta registrado en la web, por favor primero regístrese antes de continuar',
              type: 'warning'
            });
            this.auth.signOut();
          });
          // tslint:disable-next-line:triple-equals
        }
      }

    });
    this._route.params.forEach((params: Params) => {
      this.parametro = params['page'];
    });
    this.datos = 'sin nombre';
    this.loginData = {
      usuario: '',
      contrasena: ''
    };
  }

  submitLoginForm(loginForm: NgForm) {
    if (loginForm.valid) {
      // Prepare the JWT
      // Header
      if (loginForm.valid) {
        const oHeader = { alg: 'HS256', typ: 'JWT' };
        // Payload
        const oPayload: any = {};
        oPayload.usuario = this.loginData.usuario;
        oPayload.contrasena = this.loginData.contrasena;
        const sHeader = JSON.stringify(oHeader);
        const sPayload = JSON.stringify(oPayload);

        const sJWT = KJUR.jws.JWS.sign('HS256', sHeader, sPayload, 'Vbxq2mlbGJw8XH+ZoYBnUHmHga8/o/IduvU/Tht70iE=');

        this._loginService.normalLogin(sJWT).subscribe(
          (response: any) => {
            localStorage.setItem('jwt', response.JWT);
            this._router.navigate(['system']);

            this._userService.obtenerDatosPersonales()
              .subscribe(
                (userResponse: any) => {
                  localStorage.setItem('rolIdUser', userResponse.rol);
                  localStorage.setItem('nombreCompleto', userResponse.nombres + ' ' + userResponse.apellidos);
                }, error => {
                  console.log('error', error)
                }
              )
          },
          err => {
            this.notifierService.systemNotify({
              title: 'Error',
              message: 'Ha ocurrido un error, por favor contactese con su adminstrador, error: ' + err,
              type: 'error'
            });
          }
        );
      } else {
        this.notifierService.systemNotify({
          title: 'Alerta',
          icon: 'fa-eye',
          message: 'Por favor revise que los campos estén correctamente llenados y vuélvalo a intentar',
          type: 'warning'
        });
      }

    }
  }
  // login con facebook
  login() {
    /*const loginOptions: LoginOptions = {
      enable_profile_selector: true,
      return_scopes: true,
      scope: 'public_profile,user_friends,email,pages_show_list'
    };
    this.fb.login(loginOptions)
      .then((response: LoginResponse) => {
        this.fb.api('/me')
          .then((res: any) => {
            this.nombre = res.name;
          });

        this.saveContactFacebook(response.authResponse.accessToken);
      })

      .catch((error: any) => console.error(error));*/
  }
  saveContactFacebook(id_token) {
    this._loginService.addUserFacebook(id_token).subscribe(
      response => {
        localStorage.setItem('jwt', response.JWT);
        if (response.code === 200) {
          this._router.navigate(['/system/', { user: this.nombre }]);
        } else {
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }


  // login con gmail
  onGoogleSignInSuccess(/*event: GoogleSignInSuccess*/) {
    /*const googleUser: gapi.auth2.GoogleUser = event.googleUser;
    const id: string = googleUser.getId();
    const profile: gapi.auth2.BasicProfile = googleUser.getBasicProfile();
    /* const datos; */
    /*this.nombre = profile.getName();

    this._loginService.setName(this.nombre);

    this.nombre = profile.getName();
    const id_token: any = event.googleUser.getAuthResponse().id_token;
    this.saveProducto(id_token);
    googleUser.disconnect();*/
  }

  signInWithGoogle(): void {
    console.log("hello")
    this.auth.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  saveProducto(id_token) {
    this._loginService.addUser(id_token).subscribe(
      response => {
        localStorage.setItem('jwt', response.JWT);
        if (response.code === 200) {
          this.zone.run(() => { this._router.navigate(['system']); });
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/public/login/login.component.ts